const buildStorage = (name: string) => ({
  get: () => localStorage.getItem(name),
  has: () => !!localStorage.getItem(name),
  remove: () => localStorage.removeItem(name),
  set: (payload: string) => localStorage.setItem(name, payload),
})

export const organizationStorage = buildStorage('currentOrganizationUuid')
export const accessTokenStorage = buildStorage('accessToken')
export const localeStorage = buildStorage('locale')
export const themeStorage = buildStorage('theme')

